<template>
  <div>
    <div class="row1">
		<div id="">
			
		</div>
      <div class="dis-flex">
       <!-- <el-input
          size="small"
          clearable
          placeholder="搜索广告位名称"
          prefix-icon="el-icon-search"
          v-model="searchVal"
        >
        </el-input>
        <el-button
          @click="onSearch"
          class="row-btn add search"
          type="primary"
          size="small"
          >搜索</el-button
        > -->
      </div>
    </div>
    <div class="tab-box">
      <el-collapse v-model="activeName" accordion>
        <el-collapse-item title="一致性 Consistency" name="1">
          <div>与现实生活一致：与现实生活的流程、逻辑保持一致，遵循用户习惯的语言和概念；</div>
          <div>在界面中一致：所有的元素和结构需保持一致，比如：设计样式、图标和文本、元素的位置等。</div>
        </el-collapse-item>
        <el-collapse-item title="反馈 Feedback" name="2">
          <div>控制反馈：通过界面样式和交互动效让用户可以清晰的感知自己的操作；</div>
          <div>页面反馈：操作后，通过页面元素的变化清晰地展现当前状态。</div>
        </el-collapse-item>
        <el-collapse-item title="效率 Efficiency" name="3">
          <div>简化流程：设计简洁直观的操作流程；</div>
          <div>清晰明确：语言表达清晰且表意明确，让用户快速理解进而作出决策；</div>
          <div>帮助用户识别：界面简单直白，让用户快速识别而非回忆，减少用户记忆负担。</div>
        </el-collapse-item>
        <el-collapse-item title="可控 Controllability" name="4">
          <div>用户决策：根据场景可给予用户操作建议或安全提示，但不能代替用户进行决策；</div>
          <div>结果可控：用户可以自由的进行操作，包括撤销、回退和终止当前操作等。</div>
        </el-collapse-item>
      </el-collapse>
      <!-- 分页 -->
      <div class="page-box" v-if="tableData.length">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 15, 20, 30, 50, 100]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
	<!-- 查看更多弹框 -->
	<offer-more :tableData="moreTabData" ref="moreDialog"></offer-more>
  </div>
</template>

<script>
	import offerMore from "../../components/dialog/order/offer.vue";
export default {
	components: {
	  offerMore,
	},
  data() {
    return {
		moreTabData:[],
      tableData: [],
	  pageObj: {
	  	limit: 10,
	  	page: 1,
		filter: {},
		op: {}
	  },
	  total: 0, //总条数
      multipleSelection: [], //勾选的数据
      currentPage: 1, //当前页
      loading: true, //是否显示加载中图标
      searchVal: "", //搜索框值
    };
  },
  created() {
    this.getList();
  },
  methods: {
	  // 获取cookie
	  getCookie(name) {
	   var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
	   if (arr = document.cookie.match(reg))
	    return (arr[2]);
	   else
	    return null;
	  },
	  // 下载表格
	  downLoadTab(id){
		// location.href = this.$baseUrl + '/admin/offer/downloadXls?id='+id+'&PHPSESSID='+this.getCookie('PHPSESSID')  
		window.open(this.$baseUrl + '/admin/offer/downloadXls?id='+id+'&PHPSESSID='+this.getCookie('PHPSESSID'))
		
	  },
	  //查看全部
	  lookAll(item){
		  this.moreTabData = item;
		  this.$refs.moreDialog.dialogVisible = true;
	  },
    //搜索
    onSearch(){
		this.pageObj.page = 1
		// this.pageObj.filter.brand = this.searchVal;
		this.pageObj.filter.name = this.searchVal;
		// this.pageObj.op.brand = '%*%'
		this.pageObj.op.name = '%*%'
		this.getList()
    },
	//生成订单
	createOrder(id){
		this.$confirm('确认生成订单？', '提示').then(() => {
			 this.$api2.createOrder({id:id}).then((res)=>{
			 	if(res.code == 1){
			 		this.$message.success(res.msg)
			 		this.getList()
			 	}else{
			 		this.$message.error(res.msg)
			 	}
			 })
		}).catch(()=>{})
		
	},
    // 获取数据列表
    getList() {
		this.loading = true;
      this.$api2.offerList(this.pageObj).then(res => {
      	this.loading = false;
      	if (res.code == 1) {
      		this.total = res.count;
      		this.tableData = res.data;
      	}
      })
      .catch(err => {
      	this.loading = false;
      });
    },
    // 多选事件
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(val);
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
	  this.pageObj.limit = val;
	  this.getList();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
	  this.pageObj.page = val;
	  this.getList();
    },
  },
};
</script>

<style lang="scss" scoped="">
@import "../../assets/css/public.scss";
.row1 {
  align-items: center;
  justify-content: space-between;
}
.search {
  margin-left: 10px;
  margin-right: 0 !important;
}
.handle-box {
    display: flex;
    justify-content: space-around;
}
.tab-box /deep/{
	border: 1px solid #EBEEF5;
	border-top: none;
	width: 50vw;
	margin: 0 auto;
	padding-bottom: 20px;
	.el-collapse-item{
		.el-collapse-item__header{
			padding-left: 20px;
		}
	}
	
}
</style>